import React, { useMemo } from "react";
import ChatLayout from "../../components/chat/ChatLayout";
import { useAuth } from "../../context/AuthContext";

function Chat() {
  const { user } = useAuth();

  const organizationId = useMemo(() => {
    if (user?.organization && typeof user.organization === "object") {
      return user.organization.id;
    }
    return user?.organization || null;
  }, [user]);

  if (!user) {
    return (
      <div className="page-content">
        <div className="card">Please log in to access chat.</div>
      </div>
    );
  }

  if (!organizationId) {
    return (
      <div className="page-content">
        <div className="card">
          No organization assigned. Please contact your administrator.
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <ChatLayout organizationId={organizationId} />
    </div>
  );
}

export default Chat;
